var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('h3',{staticClass:"titit"},[_vm._v("漏水报警")]),_c('dv-scroll-board',{staticStyle:{"width":"95%","height":"75%"},attrs:{"config":_vm.config}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }